import script from "./CPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./CPagination.vue?vue&type=script&setup=true&lang=ts"

import "./CPagination.vue?vue&type=style&index=0&id=7f9ea00a&scoped=true&lang=scss"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f9ea00a"]])

export default __exports__